export default {
  title: {
    en: 'Update your account',
  },
  text: {
    en: 'In order to access limited edition makeup, you must have an active subscription with monthly delivery.',
  },
  confirmButton: {
    en: 'Cancel skip',
  },
  cancelButton: {
    en: 'No, I\'m okay if I never receive it',
  },
}
